<template>
    <filters-block :title="localizeList.airlineUpper" :open="open">
        <base-input v-model="search" class="search mb-10"
                    :placeholder="localizeList.titleUpper"
                    clearable>
            <icon name="search" width="20px" height="20px" fill="var(--lighten-7-color)"/>

        </base-input>
        <div class="airline-list">
            <div v-for="(item, key) in presentAirlineList"
                 :key="key">
                <div v-if="!(item.isDisabled && !ticketsAirlinesChecked[item.Key])" class="airline-item">
                    <checkbox v-model="ticketsAirlinesChecked[item.Key]"
                              @change="changeTourAirlines(item.Key, $event)">
                        <span class="ellipsis" :title="item.Name">{{item.Name}}</span>
                    </checkbox>
                </div>
            </div>
            <div v-show="!presentAirlineList.length">
                <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
            </div>
        </div>
        <div class="airline-item border-t class-combo">
            <checkbox v-model="ticketsAirlineMulty.isChecked" @change="changeTourAirlineMulty($event)">
                <span class="ellipsis" :title="localizeList.allowCombineTariffs">{{localizeList.allowCombineTariffs}}</span>
            </checkbox>
            <div class="help-icon"
                 @mouseleave="hidePopover()"
                 @mouseenter="showPopover(localizeList.allowCombineTariffsDescr, $event)">
                <icon name="help" width="14px" height="14px" class="ml-2" fill="var(--primary-color)"/>

            </div>
        </div>
    </filters-block>
</template>

<script>
    import FiltersBlock from "../../tour/secondFilters/leftFilters/filtersBlock";
    import {bus} from '@/main'

    export default {
        name: "airlines",
        props: {
            ticketsAirlineList: {
                type: Array,
                required: true
            },
            ticketsAirlinesChecked: {
                type: Object,
                required: true
            },
            ticketsAirlineMulty: {
                type: Object,
                required: true
            },
            open: {
                type: Number,
                default: 0
            },
        },
        components: {
            FiltersBlock
        },
        computed: {
            presentAirlineList() {
                let res = this.ticketsAirlineList;
                if (this.search)
                    res = res.filter(x => x.Name.toLowerCase().includes(this.search.toLowerCase()));

                return res
            }
        },
        data() {
            return {
                search: ""
            }
        },
        created() {
            bus.$on("left-tickets-filters-reset-search", () => {
                this.search = "";
            })
        },
        methods: {
            changeTourAirlines(key, e) {
                this.$parent.$parent.$parent.changeTourAirlines(key, e)
            },
            changeTourAirlineMulty(e) {
                this.$parent.$parent.$parent.changeTourAirlineMulty(e)
            },
            showPopover(text, e) {
                this.$parent.$parent.$parent.showPopover(text, e)
            }
        }
    }
</script>

<style scoped>

    .airline-list {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 175px;
    }

    .vertical-filters .airline-list {
        max-height: 340px;
    }

    .airline-list .airline-item {
        padding: 7px 0;
        display: flex;
        align-items: center;
    }

    .airline-item.class-combo {
        display: flex;
        align-items: center;
        padding-top: 10px;
        margin-top: 3px;
    }

</style>